// This helper function is used to extract and normalize query string values from the URL.
// It handles cases where the value might be an array (due to multiple query parameters with the same name)
// and ensures that the returned value is a non-empty string or undefined if the value is invalid.
export const getQueryStringValue = (value: unknown) => {
  const normalizedValue = Array.isArray(value) ? value[0] : value;
  if (typeof normalizedValue !== "string") return undefined;

  const trimmedValue = normalizedValue.trim();
  return trimmedValue.length > 0 ? trimmedValue : undefined;
};
